import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'DeviceRegistration',
  components: {
    FibConfig: require('@/pages/settings/DownloadSurveys').default,
    FibDefaultSurvey: require('@/pages/settings/DefaultSurvey').default,
    FibRegister: require('@/pages/settings/DeviceSettings').default,
    FibTeam: require('@/pages/manageTeam/ManageTeam').default
  },
  data: function data() {
    return {
      background: false,
      centred: true,
      config: false,
      configResult: null,
      register: false,
      survey: false,
      team: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, get('config', ['branchId', 'registered', 'teamPinsEnabled'])), get('manageTeam', ['hasActiveTeamMember'])), get('settings', ['defaultTemplate'])), {}, {
    bgImage: get('theme/bgImageSetting'),
    configDownloaded: function configDownloaded() {
      return this.$store.get('config/config') !== null && this.$store.get('surveys/surveys') !== null;
    }
  }),
  mounted: function mounted() {
    this.updateFlow();
  },
  methods: {
    done: function done(step) {
      this[step.name] = false;

      if (step.name === 'register') {
        this.configResult = null;
      }

      if (step.name === 'config') {
        this.configResult = step.result;
      }

      this.updateFlow();
    },
    updateFlow: function updateFlow() {
      this.background = false; // Background hidden by default and enabled below when required

      this.centred = false;

      if (!this.registered) {
        this.background = true;
        this.centred = true;
        this.register = true; // Register Device process
      } else if (this.registered && !this.configDownloaded) {
        // if (this.configResult === null) {
        this.background = true;
        this.centred = true;
        this.config = true; // Show the Download Config process

        this.register = !this.configResult; // }
      } else if (this.configDownloaded && this.defaultTemplate === null && this.$store.get('surveys/surveys.length') > 0) {
        Logger.debug('Prompt for Default Survey');
        this.background = true;
        this.register = false; // Hide the Register Device form

        this.survey = true;
      } else if (this.teamPinsEnabled && !this.hasActiveTeamMember) {
        Logger.debug('Prompt for Team Members');
        this.team = true;
      } else {
        // Set the setup complete flag and redirect to landing page
        this.$store.set('settings/setupComplete', true);
        Logger.debug('Setup complete, navigate to Team Landing page');
        this.$router.push('/staff');
      }
    }
  }
};